import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function PatientBilling() {
  return <V20Embed view="patientbilling" testid="patient-billing-view" />;
}
